import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongDetail(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(1);


    return (
        <>
            <div className='ws-12'>
                <div className="ws-12">
                    <div className="ws-6"> &nbsp;</div>

                    <div className="ws-6">
                        <ul className="nav nav-tabs ps pl">
                            <div  >
                                <li className={showSubtab == 1 ? "btn-l active" : "btn-l"} onClick={() => setShowSubTab(1)}><a>Class</a></li>
                                <li className={showSubtab == 2 ? "btn-l active" : "btn-l"} onClick={() => setShowSubTab(2)}><a>Copyright</a></li>
                                <li className={showSubtab == 3 ? "btn-l active" : "btn-l"} onClick={() => setShowSubTab(3)}><a>Status</a></li>
                            </div>

                        </ul>
                    </div>

                </div>

                <div className="ws-6 pr">
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border"> <h2> Song Info</h2> </legend>

                        <div className="ws-12">
                            <div className="ws-6">
                                <div className={(showtab == 1) ? "" : "hide"}>
                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Song Ref*</label>
                                        <div className="label-entries"><input type="text" name="songRef" className="form-control" placeholder="Song Ref" /></div>
                                    </div>

                                    <div className="form-format m0 mtl hide">
                                        <label className="control-label ">SongID</label>
                                        <div className="label-entries"><input type="text" name="songID" className="form-control " /></div>
                                    </div>

                                    <div className="form-format m0 mtl">
                                        <label className="control-label">ISWC*</label>
                                        <div className="label-entries"><input type="text" name="intStdWorkCode" className="form-control" placeholder="ISWC" /></div>
                                    </div>

                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Song Title*</label>
                                        <div className="label-entries">
                                            <input type="text" name="songTitle" className="form-control" placeholder="Song Title" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="ws-6">

                                <div className={(showtab == 1) ? "" : "hide"}>
                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Song Main Publisher</label>
                                        <div className="label-entries"><input type="text" name="songName" className="form-control" placeholder="Song Main Publisher" /></div>
                                    </div>

                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Song Main Composer</label>
                                        <div className="label-entries"><input type="text" name="songName" className="form-control" placeholder="Song Main Composer" /></div>
                                    </div>
                                    <div className="form-format m0 mtl hide">
                                        <label className="control-label ">Song Main Lyricist </label>
                                        <div className="label-entries">
                                            <div className="input-group">
                                                <input type="text" className="form-control text-uppercase" placeholder="Song Main Lyricist" name="songMainLyricist" />
                                                <span className="input-group-btn"><button type="button" className="icon-btn edit" ><i className="icon-user-add"></i></button></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-format m0 mtl hide">
                                        <label className="control-label ">Song Conductor</label>
                                        <div className="label-entries">
                                            <div className="input-group">
                                                <input type="text" className="form-control text-uppercase " placeholder="Song Conductor" name="songConductor" />
                                                <span className="input-group-btn"><button type="button" className="icon-btn edit"><i className="icon-user-add"></i></button></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Title Version</label>
                                        <div className="label-entries"><input type="text" name="titleVersion" className="form-control" placeholder="Title Version" /></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </fieldset>
                </div>

                <div className="ws-6 pr">

                    <fieldset className="scheduler-border " >
                        <legend className="scheduler-border">
                            <h2>ClassName </h2>
                        </legend>

                        <div className={showSubtab == 1 ? "ws-12" : "ws-12 hide"}>
                            <div className="ws-6">
                                <div className="form-format m0 mtl hide">
                                    <label className="control-label ">Production Name</label>
                                    <div className="label-entries">
                                        <input type="text" name="productionName" className="form-control " placeholder="Production Name" />
                                    </div>
                                </div>

                                <div className="form-format m0 mtl hide" >
                                    <label className="control-label ">Controlled %</label>
                                    <div className="label-entries">
                                        <input type="text" name="controlledPercentage" className="form-control " placeholder="Controlled %" />
                                    </div>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="form-format m0 mtl">
                                    <label className="control-label " >DIM 1</label>
                                    <div className="label-entries"><input type="text" placeholder="Enter DIM 1" name="catCoMedia" /></div>
                                </div>

                                <div className="form-format m0 mtl">
                                    <label className="control-label ">DIM 2</label>

                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter DIM 2" className="form-control" id="frmformatListing.analysisDiM2" name="catCoMediaCode" />
                                    </div>
                                </div>

                                <div className="form-format m0 mtl">
                                    <label className="control-label ">DIM 3</label>

                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter DIM 3" className="form-control " id="frmformatListing.analysisDIM3" name="analysisDIM3" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={showSubtab == 2 ? "ws-12" : "ws-12 hide"}>
                            <div className="ws-6">
                                <div className="form-format m0 mtl ">
                                    <label className="control-label ">Copyright Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="songCYear" className="form-control " placeholder="Copyright Number" />
                                    </div>
                                </div>

                                <div className="form-format m0 mtl " >
                                    <label className="control-label ">Copyright Date</label>
                                    <div className="label-entries">
                                        <input type="text" name="songCHolder" className="form-control " placeholder="Copyright Date" />
                                    </div>
                                </div>

                                <div className="form-format m0 mtl " >
                                    <label className="control-label ">Genre</label>
                                    <div className="label-entries">
                                        <input type="text" name="songGenre" className="form-control " placeholder="Genre" />
                                    </div>
                                </div>

                            </div>

                            <div className="ws-6">
                                <div className="form-format m0 mtl">
                                    <label className="control-label " >Mood</label>
                                    <div className="label-entries"><input type="text" placeholder="Mood" name="mood" /></div>
                                </div>

                                <div className="form-format m0 mtl">
                                    <label className="control-label ">ERA</label>

                                    <div className="label-entries">
                                        <input type="text" placeholder="ERA" className="form-control" name="eRA" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={showSubtab == 3 ? "ws-12" : "ws-12 hide"}>
                            <div className="form-format m0 mtl">
                                <label className="control-label ">Song Status</label>
                                <div className="label-entries">
                                    <select name="songStatus" className="full-width">
                                        <option value="">Choose Status</option>
                                        <option value="0" label="Released">Released</option>
                                        <option value="1" label="Not Released">Not Released</option>
                                        <option value="2" label="Never Released">Never Released</option>
                                        <option value="3" label="Sold">Sold</option>
                                        <option value="4" label="In Set-up">In Set-up</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-format m0 mtl">
                                <label className="control-label ">Extended Status</label>
                                <div className="label-entries">
                                    <select name="songStatusSplits" className="full-width">
                                        <option value="">Choose Status</option>
                                        <option value="0" label="Released">Released</option>
                                        <option value="1" label="Never Released">Never Released</option>
                                        <option value="2" label="Not Released">Not Released</option>
                                        <option value="3" label="Sold">Sold</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </fieldset>
                </div>
            </div>
        </>
    )

}